__turbopack_context__.v({
  "desktopActions": "Header-module__zCemKG__desktopActions",
  "desktopNav": "Header-module__zCemKG__desktopNav",
  "headerWrapper": "Header-module__zCemKG__headerWrapper",
  "loginBtn": "Header-module__zCemKG__loginBtn",
  "logo": "Header-module__zCemKG__logo",
  "mobileActions": "Header-module__zCemKG__mobileActions",
  "mobileMenu": "Header-module__zCemKG__mobileMenu",
  "mobileMenuButton": "Header-module__zCemKG__mobileMenuButton",
  "nav": "Header-module__zCemKG__nav",
  "registerBtn": "Header-module__zCemKG__registerBtn",
  "scrolled": "Header-module__zCemKG__scrolled",
  "slideDown": "Header-module__zCemKG__slideDown",
});
